<template>
  <section hidden="true">
    <h2>Challenges and Solutions</h2>
    <p>Discuss any significant challenges you faced and how you overcame them.</p>
    <p>This can demonstrate problem-solving skills and resilience.</p>
  </section>
</template>

<script>
export default {
  name: 'ChallengesSolutionsSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>